// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6319a787","732":"1be79142","977":"7a71a01c"}[chunkId] + ".chunk.js";
};